module.exports = __webpack_public_path__ + "img/img182.2a68c41f.png";